import React from 'react'
import { IconButton, useTheme } from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { Container } from '../Container'
import { useFinderStyles } from '../Finder/styles'

interface Props {
    level: number
    myKey: string
    selected: boolean
    children: React.ReactNode
    selectedIcon?: JSX.Element
    showSelectionIcon?: boolean
    onClickIcon?: () => void
    showSortControls?: boolean
    sortOrder?: 'asc' | 'desc'
    onSortToggle?: () => void
}

export const SortableFinderItem: React.FC<Props> = (props) => {
    /**
     * SortableFinderItem extends FinderItem with sorting capabilities
     * 1. Creates spacer components for visual indentation
     * 2. On hover displays the visibility button for finder filtering
     * 3. Adds sort controls when sorting is enabled
     */

    const theme = useTheme()
    const classes = useFinderStyles()

    const spacers: JSX.Element[] = []
    for (let curLevel = 1; curLevel < props.level + 1; curLevel++) {
        spacers.push(
            <div
                key={`${props.myKey}_${curLevel}`}
                style={{
                    width: 25,
                    height: '100%',
                    borderLeft: `1px solid ${theme.palette.secondary.main}`,
                }}
            />,
        )
    }

    let icon: JSX.Element

    if (props.selected) {
        icon = (
            <IconButton
                size="small"
                color="primary"
                onClick={props.onClickIcon}
            >
                {props.selectedIcon ? props.selectedIcon : <VisibilityIcon />}
            </IconButton>
        )
    } else {
        icon = (
            <IconButton
                size="small"
                className={classes.icon}
                color="secondary"
                onClick={props.onClickIcon}
            >
                {props.selectedIcon ? props.selectedIcon : <VisibilityIcon />}
            </IconButton>
        )
    }

    return (
        <Container className={classes.infrastructure} alignItems="center">
            {spacers}
            {props.children}
            {props.showSelectionIcon !== false && icon}
        </Container>
    )
}
